import { Calendar } from 'primereact/calendar'
import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../../stateManagement/hooks/redux'
import { setTransportHistoryChosenDate, setTransportHistoryShowOnMapButtonClicked } from '../../../../../stateManagement/reducers/transport/TransportHistorySlice'
import { convertDate } from '../../../../../features/dataFormatFunctions/dataFormatter'
import TransportListItem from './transportListItem/TransportListItem'

export default function TransportHistoryOverlay() {

    const dispatch = useDispatch()
    let calendarRef: any = useRef()
    let calendarDivRef: any = useRef()
    const date = useAppSelector(state => state.transportHistory.transportHistoryChosenDate)
    const transportHistoryCurrentDates = useAppSelector(state => state.transportHistory.transportHistoryCurrentTransportDates)
    const transportHistoryShowOnMapButtonClicked = useAppSelector(state => state.transportHistory.transportHistoryShowOnMapButtonClicked)
    const transportHistoryDrivewaysList = useAppSelector(state => state.transportHistory.transportHistoryDrivewaysList)
    const [calendarHeight, setCalendarHeight] = useState(0)

    useEffect(() => {
        date && calendarRef.current.updateViewDate(null, new Date(date))
    }, [date])

    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            setCalendarHeight(entries[0].contentRect.height)
        })
        observer.observe(calendarDivRef.current)
        return () => calendarDivRef.current && observer.unobserve(calendarDivRef.current)
    }, [])

    const transportHistoryDateTemplate = (date: any) => {
        let day = date.day
        let month = date.month + 1 // отсчет месяца в библиотеке идет с 0
        let year = date.year
        let searchResult = transportHistoryCurrentDates && transportHistoryCurrentDates.filter((listDate: any) => (listDate.day == day && listDate.month == month && listDate.year == year))[0]

        if (searchResult) {
            return (
                <div className="enabled-date">{date.day}</div>
            )
        }
        else {
            date.selectable = false;
            return (
                <div className="disabled-date">{date.day}</div>
            )
        }
    }

    function showHistoryDrivewayOnMap() {
        dispatch(setTransportHistoryShowOnMapButtonClicked(!transportHistoryShowOnMapButtonClicked))
    }

    return (
        <div className="map-overlay map-overlay-transport-history">
            <div className="date-calendar" ref={calendarDivRef}>
                <Calendar
                    value={new Date(date)}
                    ref={calendarRef}
                    onChange={(e) => dispatch(setTransportHistoryChosenDate(convertDate(e.value)))}
                    inline
                    selectOtherMonths
                    dateTemplate={transportHistoryDateTemplate}
                />
            </div>
            <div className="show-on-map-button-div">
                <button className="show-on-map-button" onClick={showHistoryDrivewayOnMap}>Показать на карте</button>
            </div>
            <div className="transport-list" style={{ height: `calc(100% - ${calendarHeight}px - 53px)` }}>
                {Array.isArray(transportHistoryDrivewaysList) &&
                    transportHistoryDrivewaysList.map((item: any) => {
                        return (
                            <TransportListItem id={item?.id} garageNumber={item?.garageNumber} carBrand={item?.carBrand} company={item?.company} />
                        )
                    })
                }
            </div>
        </div>
    )
}
